<template>
  <div class="tabs">
    <div class="tabs-header">
      <div
        :class="['tab-header', { active: label === active }]"
        v-for="label in labels"
        :key="label"
        @click="setActive(label)"
      >
        {{ label }}
      </div>
    </div>
    <div ref="contentRef" class="tabs-content">
      <slot />
    </div>
  </div>
</template>

<script>
import smoothScroll from '@/helpers/smoothScrollHelper'

export default {
  name: 'Tabs',
  props: {
    labels: {
      type: Array,
      default() {
        return []
      },
    },
    indexActive: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      active: this.labels.length && this.labels[this.indexActive],
    }
  },
  mounted() {
    this.setActive(this.active)
  },
  methods: {
    setActive(label) {
      this.active = label

      const tabIndex = this.labels.indexOf(label)
      const contentRef = this.$refs.contentRef

      smoothScroll(contentRef.childNodes[tabIndex], 'scrollTop', 0, 0).then()
      smoothScroll(contentRef, 'scrollLeft', contentRef.clientWidth * tabIndex, 0).then()
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .tabs-header {
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: white;
    position: relative;
    z-index: 5;

    .tab-header {
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
      cursor: pointer;
      height: 100%;
      width: 100%;

      &.active {
        color: $cherry;
        position: relative;

        &:before {
          position: absolute;
          content: '';
          height: 2px;
          width: 100%;
          bottom: 0;
          left: 0;
          background: $cherry;
        }
      }
    }
  }
  .tabs-content {
    flex: 1;
    display: flex;
    width: 100%;
    height: 100%;
    flex-wrap: nowrap;
    overflow: hidden;
    justify-content: flex-start !important;

    > .tab {
      flex: 0 0 auto;
      overflow-y: auto;
      width: 100%;
      height: 100%;

      padding: 20px 10px 0 10px;
    }
  }
}
</style>
